import React from 'react'
import './Wapper.css'


const Wapper = ({ children }) => {
    return <div className="wapper">{children}</div>;
};

export default Wapper;